/**
 * <SubscriptionPortalSkeleton> — la forme de l'onglet « Abonnement » pendant son premier chargement.
 *
 * Les deux colonnes de `<SubscriptionPortalTemplate>` (une seule sur un téléphone) : à gauche la
 * carte d'état — l'offre, les objectifs en chips, le statut, les lignes datées ; à droite les
 * cartes « Gestion » et « Facturation », leurs intitulés vrais et leurs lignes de réglage à la
 * hauteur des vraies (44 px, un filet entre deux). Le cas montré est l'abonnement qui court.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { columnStyles } from "../../atoms/containers/columns"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../../molecules/Card"
import { SettingsSectionSkeleton } from "../../molecules/SettingsSection"

function StateCardBones() {
    return (
        <Card p="4">
            <Stack gap="3">
                <Skeleton textSize="text-base" width={180} />
                <Row gap="2">
                    <Skeleton shape="chip" width={96} />
                    <Skeleton shape="chip" width={120} />
                </Row>
                <Skeleton textSize="text-base" width={130} />
                <Stack gap="2">
                    {[290, 210].map((width) => (
                        <Row key={width} gap="2" align="center">
                            <Skeleton shape="circle" size={16} />
                            <Skeleton textSize="text-sm" width={width} />
                        </Row>
                    ))}
                </Stack>
            </Stack>
        </Card>
    )
}

export function SubscriptionPortalSkeleton() {
    return (
        <View style={[columnStyles.columns, styles.fullWidth]}>
            <Stack gap="4" style={columnStyles.column}>
                <StateCardBones />
            </Stack>
            <Stack gap="4" style={columnStyles.column}>
                <SettingsSectionSkeleton title="Gestion" rows={3} />
                <SettingsSectionSkeleton title="Facturation" rows={4} />
            </Stack>
        </View>
    )
}

const styles = StyleSheet.create(() => ({
    /** La largeur de `<SubscriptionPortalTemplate>`, qui porte les colonnes. */
    fullWidth: { width: "100%" },
}))
